// components
import { Navbar3 } from "components/navbars";
import { Hero11 } from "components/heros";
import BackToTop from "components/BackToTop";
import { Footer1 } from "components/footer";

import Features1 from "../landings/Saas/Features1";
import Features2 from "../landings/Saas/Features2";
import Features3 from "../landings/Saas/Features3";
import Client from "../other/Company/Client"
import Testimonials from "../landings/Saas/Testimonials";
// import Pricing from "../landings/Saas/Pricing";
import FAQs from "../landings/Saas/FAQs";
import PricingPlans from "../other/Pricing/PricingPlans";


// dummy data
import { features,  payus,free,combo} from "../landings/Saas/data";

const Saas2 = () => {
  return (
    <>
      <div>
        <Navbar3
          navClass="navbar-light"
          isSticky={false}
          fixedWidth
          buttonClass="btn-primary btn-sm"
        />
        <Hero11 />
      </div>

      {/* features */}
      <Features1
        features={features}
        containerClass="position-relative overflow-hidden py-4 pb-lg-7"
      />

      <Features2 />

      <Features3 />

      {/* clients */}
      <Client />

      {/* testimonials */}
      <Testimonials />

      {/* pricing */}
      {/* <Pricing plans={plans} heading="Pricing Plans " button="Purchase Now" /> */}
      <PricingPlans plans={free} heading="Free Forever"  />
      <PricingPlans
        plans={combo}
        heading="Pricing Plans"
      />
      <PricingPlans plans={payus} heading="Pay Us You Go" />

      {/* FAQs */}
      <FAQs />

      {/* footer */}
      <Footer1 />

      <BackToTop />
    </>
  );
};

export default Saas2;
